const NETWORK_FAILURE_MESSAGES = [
  'Failed to fetch',
  'Load failed',
  'NetworkError when attempting to fetch resource.',
]

export function isNetworkFailure(error) {
  return error instanceof TypeError &&
    NETWORK_FAILURE_MESSAGES.some((message) => error.message.startsWith(message))
}
